import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M915.1 525.9H662V255H362v270.8H108.9L512 949l403.1-423.1z m-253.1 50h136.4L512 876.5 225.6 575.9H412V305h200v270.8h50zM362 165h300v50H362zM362 75h300v50H362z\" fill=\"#fa5252\" p-id=\"10329\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 103